<template>
  <div class="content">
    <baidu-map
      class="map"
      :center="mapCenter"
      :zoom="mapZoom"
      :minZoom="5"
      :maxZoom="14"
      :mapClick="false"
      :scrollWheelZoom="true"
      :double-click-zoom="false"
    >
      <bm-boundary
        class="safety-map-boundary"
        :name="mapCenter"
        :strokeWeight="2"
        strokeColor="blue"
        fillColor="rgba(255,255,255,0.6)"
      >
      </bm-boundary>
      <div
        class="list"
        v-for="(item, index) in markerLists"
        :key="item.company_lat"
      >
        <bm-marker
          :position="{ lng: item.company_lon, lat: item.company_lat }"
          :title="item.school_name"
          :zIndex="index"
          :icon="{
            url: schoolIcon,
            size: { width: 30, height: 54 }
          }"
          @click="infoWindowOpen(item, index)"
        >
          <!-- <bm-label
            v-if="false"
            :content="item.school_name"
            :labelStyle="{
              color: '#2B2D39',
              fontSize: '14px',
              fontWeight: '600',
              border: 'none',
              background: 'transparent'
            }"
            :offset="{ width: -22, height: 40 }"
          ></bm-label> -->
          <bm-info-window
            :position="item.markerPo"
            :show="item.showInfoWindow"
            @close="infoWindowClose(item, index)"
            @open="infoWindowOpen(item, index)"
          >
            <div class="">
              <div class="school">{{item.school_name}}</div>
              <div class="device">设备数量：{{item.device_count}}</div>
              <div class="address">地址：{{item.area}}{{item.address_des}}</div>
            </div>
          </bm-info-window>
        </bm-marker>
      </div>
    </baidu-map>
  </div>
</template>

<script>
import Vue from "vue";
import BaiduMap from "vue-baidu-map/components/map/Map.vue";
import BmView from "vue-baidu-map/components/map/MapView"; //地图视图
import BmMarker from "vue-baidu-map/components/overlays/Marker"; //点标注
import BmLabel from "vue-baidu-map/components/overlays/Label"; //点标注label
import BmInfoWindow from "vue-baidu-map/components/overlays/InfoWindow"; //标注弹窗
export default {
  name: "",
  components: {
    BaiduMap,
    BmView,
    BmMarker,
    BmLabel,
    BmInfoWindow
  },
  props: {
    schoolList: {
      type: Array,
      default: {
        return: []
      }
    }
  },
  data() {
    return {
      mapCenter: "鹤壁",
      mapZoom: 11,
      schoolIcon: require("@/assets/img/baiduMapIcon/map-school-icon.png"),
      markerLists: []
    };
  },
  created() {},
  watch: {
    schoolList: {
      handler(newName, oldName) {
        // this.markerLists = newName.filter((item)=>{
        //    return item.type == 'edu'
        // })
        this.$nextTick(() => {
          //   this.loadChart();
          this.showName = false;
          this.markerLists = [];
          this.markerLists = newName;
        });
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 弹框关闭
    infoWindowClose(item, index) {
      this.markerLists[index].showInfoWindow = false;
      this.infoWindowInfo = {};
    },
    // 点击图标
    infoWindowOpen(item, index) {
      let obj = this.markerLists[index];
      if (!obj.showInfoWindow) {
        obj.showInfoWindow = true;
        Vue.set(this.markerLists, index, obj);
        // if (obj.type == "school") {
        //   // 当前点击的是学校
        //   this.getSchoolInfo(obj);
        // } else {
        //   // 当前点击的是教育局
        //   this.getEduInfo(obj);
        // }
        // this.$emit("mapClickMarker", obj);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  height: 100%;
  /deep/ .map {
    .anchorBL {
      display: none;
    }
  }
}
.map {
  margin: 0px 0px 0px 0px;
  width: 100%;
  height: 100%;
  position: relative;
  .school {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #1573DA;
    text-align: center;
  }
  .device {
    font-size: 14px;
    color: gray;
  }
  .address {
    font-size: 14px;
    color: gray;
  }
}
</style>
